export default __webpack_public_path__ + "static/colibri-dossier-1-3de55a0acd5043fd5d8b5cce2e09bb41.pdf";